<app-base-dialog sizeClass="size-18" [noPadding]="true" [useParentHeight]="true">
	<div class="container">
		<div class="search-header">
			<app-instant-search-box (fire)="groeperingFilter.set($event)" placeholder="Zoeken..."></app-instant-search-box>
		</div>
		@if (groeperingen().length > 0) {
			<app-groepering-list class="groeperingen" [groeperingCategorieen]="groeperingen()" (selected)="dialogRef.close($event)"></app-groepering-list>
		} @else {
			<div class="no-results">Geen groeperingen gevonden</div>
		}
	</div>
</app-base-dialog>
